import { Box, Button } from '@mui/material';
import { FC } from 'react';

import { theme } from '../../services/theme';
import { FormSubmitButton } from '../forms/SubmitButton';
import { FormTextField } from '../forms/TextField';

const inputBoxStyle = {
  width: 'calc((100% / 3) - 20px)',
  margin: '0 20px 20px 0',
  [theme.breakpoints.down('md')]: {
    width: 'calc((100% / 3) - 10px)',
    margin: '0 10px 20px 0',
  },
  [theme.breakpoints.down('sm')]: {
    width: 'calc((100% / 2) - 15px)',
    margin: '0 15px 15px 0',
  },
  [theme.breakpoints.down('mobile')]: {
    width: '100%',
    margin: '0 0 15px',
  },
};

interface FormValues {
  email: string;
  firstName: string;
  lastName: string;
}

interface Props {
  values: FormValues;
  setFieldValue: any;
  onCancel: () => void;
}

export const EditAdminFormContent: FC<Props> = ({
  values,
  setFieldValue,
  onCancel,
}) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          marginBottom: '10px',
          [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap',
          },
        }}
      >
        <Box sx={inputBoxStyle}>
          <FormTextField
            label="WorkBetter admin first name"
            name="firstName"
            placeholder="First"
          />
        </Box>
        <Box sx={inputBoxStyle}>
          <FormTextField
            label="WorkBetter admin last name"
            name="lastName"
            placeholder="Last"
          />
        </Box>
        <Box sx={inputBoxStyle}>
          <FormTextField
            label="WorkBetter admin email"
            name="email"
            placeholder="example@email.com"
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          marginBottom: '10px',
        }}
      >
        <Button
          onClick={onCancel}
          sx={{ height: '36px', width: '150px', marginRight: '25px' }}
          variant="outlined"
        >
          Cancel
        </Button>
        <FormSubmitButton
          sx={{ height: '36px', marginTop: '0px', width: '170px' }}
          title="Submit"
        />
      </Box>
    </>
  );
};
